<template>
  <HeaderComp/>
  <section class="mb-8">
    <h3 class="text-4xl py-8">6月</h3>
    <template v-for="day in days" :key="day.key">
      <span class="mx-4 p-2 cursor-pointer" :class="{curr: currentday === day.key}" @click="selectday(day)">
        {{ day.value }}
      </span>
      <br v-if="day.id === 4" />
    </template>
  </section>
  <section class="carousel">
    <div class="carousel__main">
      <transition name="active">
        <div class="carousel__main" :key="images[currentdayno-1][currentday][active-1].id" v-show="active === images[currentdayno-1][currentday][active-1].id">
          <img :src="images[currentdayno-1][currentday][active-1].img" class="carousel__main__img">
        </div>
      </transition>
    </div>
    <div @click="prev" class="carousel__prev">＜</div>
    <div @click="next" class="carousel__next">＞</div>
  </section>
  <section>
    <span class="mr-8">朝</span>
    <span class="mr-8">昼</span>
    <span>夜</span>
    <ul class="carousel__thumbnails">
      <li v-for="n in 3" :key="n" :class="{current: active === n}" @click="current(n)">
        <img :src="images[currentdayno-1][currentday][n-1].img">
      </li>
    </ul>
  </section>
  <section class="my-4">
    <transition name="active">
      <div :key="images[currentdayno-1][currentday][active-1].id" v-show="active === images[currentdayno-1][currentday][active-1].id">
        {{ images[currentdayno-1][currentday][active-1].text }}
      </div>
    </transition>
  </section>
  <FooterComp/>
</template>

<script>
import HeaderComp from './components/HeaderComp.vue'
import FooterComp from './components/FooterComp.vue'

export default {
  name: 'App',
  components: {
    HeaderComp,
    FooterComp
  },
  data() {
    return {
      currentday: 'day0601',
      currentdayno: 1,
      active: 1,
      days: [
        {id:1, key: 'day0601', value: '１日'},
        {id:2, key: 'day0602', value: '２日'},
        {id:3, key: 'day0603', value: '３日'},
        {id:4, key: 'day0604', value: '４日'},
        {id:5, key: 'day0605', value: '５日'},
        {id:6, key: 'day0606', value: '６日'},
        {id:7, key: 'day0607', value: '７日'}
      ],
      images: [
        {
          day0601: [
            {id:1, img: '/images/img99.JPG', text: '食べてません'},
            {id:2, img: '/images/img01.JPG', text: 'ごはん、味噌汁、豚しゃぶ'},
            {id:3, img: '/images/img02.JPG', text: 'ごはん、しらす、鮭のムニエル'}
          ]
        },
        {
          day0602: [
            {id:1, img: '/images/img99.JPG', text: '食べてません'},
            {id:2, img: '/images/img03.JPG', text: 'ごはん、味噌汁、しめじ、鮭のムニエル'},
            {id:3, img: '/images/img04.JPG', text: 'ごはん、しらす、エビチリ'}
          ]
        },
        {
          day0603: [
            {id:1, img: '/images/img99.JPG', text: '食べてません'},
            {id:2, img: '/images/img05.JPG', text: 'パン、そば、ブロッコリー塩昆布和え'},
            {id:3, img: '/images/img06.JPG', text: 'ごはん、味噌汁、ブロッコリー塩昆布和え、ポークステーキ'}
          ]
        },
        {
          day0604: [
            {id:1, img: '/images/img99.JPG', text: '食べてません'},
            {id:2, img: '/images/img07.JPG', text: 'ネギトロごはん、味噌汁、もやし炒め'},
            {id:3, img: '/images/img08.JPG', text: 'ごはん、味噌汁、ブロッコリー塩昆布和え、ポークステーキ'}
          ]
        },
        {
          day0605: [
            {id:1, img: '/images/img99.JPG', text: '食べてません'},
            {id:2, img: '/images/img09.JPG', text: 'ごはん、もやし豚バラ炒め'},
            {id:3, img: '/images/img10.JPG', text: '味噌汁、マグロのカマ焼き、つぶ貝'}
          ]
        },
        {
          day0606: [
            {id:1, img: '/images/img99.JPG', text: '食べてません'},
            {id:2, img: '/images/img11.JPG', text: 'ごはん、しらす、キムチ鍋、ポークステーキ'},
            {id:3, img: '/images/img12.JPG', text: 'ごはん、しらす、味噌汁、イカゲソ'}
          ]
        },
        {
          day0607: [
            {id:1, img: '/images/img99.JPG', text: '食べてません'},
            {id:2, img: '/images/img13.JPG', text: 'ごはん、納豆、味噌汁'},
            {id:3, img: '/images/img14.JPG', text: 'ごはん、味噌汁、ローストチキン、ブロッコリー塩昆布和え'}
          ]
        }
      ]
    }
  },
  methods: {
    selectday(obj) {
      this.currentday = obj.key;
      this.currentdayno = obj.id;
      this.active = 1;
    },
    current(id) {
      this.active = id;
    },
    prev() {
      if (this.active === 1) {
        this.active = 3;
      } else {
        this.active--;
      }
    },
    next() {
      if (this.active === 3) {
        this.active = 1;
      } else {
        this.active++;
      }
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
